module.exports = "TITLE=todos\nINPUT_PLACEHOLDER=What needs to be done?\nITEM_LEFT=item left\nITEMS_LEFT=items left\nCLEAR_COMPLETED=Clear completed\n"